"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FileVolume {
    constructor({ maxVolume }) {
        this.toJSON = () => ({
            maxVolume: this.maxVolume,
        });
        this.maxVolume = maxVolume;
    }
}
FileVolume.fromJSON = (json) => {
    const { maxVolume } = Object.assign({}, json);
    // FIXME: maxVolueがnullのとき、例外が投げられないのではないか
    if (maxVolume !== null && (typeof maxVolume !== 'number' || Number.isNaN(maxVolume)))
        throw new Error('.maxVolume must be a number');
    return new FileVolume({ maxVolume });
};
exports.default = FileVolume;
